import { render } from "./VendorTable.vue?vue&type=template&id=644f3bb8&scoped=true"
import script from "./VendorTable.vue?vue&type=script&lang=js"
export * from "./VendorTable.vue?vue&type=script&lang=js"

import "./VendorTable.vue?vue&type=style&index=0&id=644f3bb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644f3bb8"]])

export default __exports__